<div class="flex-1 flex flex-col overflow-hidden">
  <!-- Users Edit Content -->
  <main class="flex-1 overflow-y-auto p-6">
    <!-- Loading State -->
    @if (loading) {
    <div class="flex justify-center items-center h-64">
      <div class="text-lg text-gray-600">Loading user data...</div>
    </div>
    } @else {
    <!-- Back Navigation and Title -->
    <div class="mb-6">
      <button
        class="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
        (click)="goBack()"
      >
        <i class="pi pi-arrow-left mr-2"></i>
        <span class="text-lg font-medium">Edit User</span>
      </button>
    </div>

    <!-- User Edit Form -->
    <div class="">
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="space-y-6">
        <div class="flex flex-col md:flex-row md:justify-between w-full gap-2">
          <!-- Name Field -->
          <div class="form-field flex-1">
            <label
              for="name"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              Name
            </label>
            <input
              id="name"
              type="text"
              pInputText
              formControlName="name"
              placeholder="Enter Name"
              class="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              [class.border-red-500]="isFieldInvalid('name')"
            />
            @if (isFieldInvalid('name')) {
            <div class="mt-1 text-sm text-red-600">Name is required</div>
            }
          </div>

          <!-- Email Address Field -->
          <div class="form-field flex-1">
            <label
              for="email"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              Email Address
            </label>
            <input
              id="email"
              type="email"
              pInputText
              formControlName="email"
              placeholder="Enter Email Address"
              class="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              [class.border-red-500]="isFieldInvalid('email')"
            />
            @if (isFieldInvalid('email')) {
            <div class="mt-1 text-sm text-red-600">
              Please enter a valid email address
            </div>
            }
          </div>
        </div>

        <div class="flex flex-col md:flex-row md:justify-between w-full gap-2">
          <!-- <div class="form-field flex-1">
              <label
                for="password"
                class="block text-sm font-medium text-gray-700 mb-2"
              >
                Password
              </label>
              <div class="relative">
                <input
                  id="password"
                  [type]="showPassword ? 'text' : 'password'"
                  pInputText
                  formControlName="password"
                  placeholder="Enter Password"
                  class="w-full p-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  [class.border-red-500]="isFieldInvalid('password')"
                />
                <button
                  type="button"
                  class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 transition-colors"
                  (click)="togglePasswordVisibility()"
                >
                  <i
                    [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
                  ></i>
                </button>
              </div>
              @if (isFieldInvalid('password')) {
              <div
                class="mt-1 text-sm text-red-600"
              >
                Password is required and must be at least 6 characters
              </div>
              }
            </div> -->

          <!-- User Type Field -->
          <div class="form-field flex-1">
            <label
              for="userType"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              User Type
            </label>
            <p-select
              id="userType"
              formControlName="userType"
              [options]="userTypeOptions"
              placeholder="Select User Type"
              optionLabel="label"
              optionValue="value"
              class="w-full"
              [class.ng-invalid]="isFieldInvalid('userType')"
              [class.ng-dirty]="isFieldInvalid('userType')"
            ></p-select>
            @if (isFieldInvalid('userType')) {
            <div class="mt-1 text-sm text-red-600">
              Please select a user type
            </div>
            }
          </div>
          <div class="lg:form-field lg:flex-1"></div>
        </div>

        <!-- Active Status Field -->
        <div class="form-field">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Active:
          </label>
          <div class="flex items-center space-x-6">
            <div class="flex items-center">
              <p-checkbox
                [binary]="true"
                [inputId]="'active-yes'"
                formControlName="isActive"
                (onChange)="onActiveStatusChange(true)"
              ></p-checkbox>
              <label
                [for]="'active-yes'"
                class="ml-2 text-sm text-gray-700 cursor-pointer"
              >
                Yes
              </label>
            </div>
            <div class="flex items-center">
              <p-checkbox
                [binary]="true"
                [inputId]="'active-no'"
                formControlName="isNonActive"
                (onChange)="onActiveStatusChange(false)"
              ></p-checkbox>
              <label
                [for]="'active-no'"
                class="ml-2 text-sm text-gray-700 cursor-pointer"
              >
                No
              </label>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col sm:flex-row justify-end gap-2 pt-6">
          <button
            type="button"
            pButton
            label="Cancel"
            class="cancel-btn w-full sm:w-auto"
            (click)="goBack()"
          ></button>
          <button
            type="submit"
            pButton
            label="Update"
            class="create-btn w-full sm:w-auto"
            [disabled]="userForm.invalid || isSubmitting"
          ></button>
        </div>
      </form>
    </div>
    }
  </main>
</div>
